import Modal from "bootstrap/js/dist/modal";

class Lightbox {
  constructor($el, $scope = null) {
    this.$el = $el;
    this.isNewsletter = this.$el.data("is-newsletter");
    if ($scope) {
      this.$target = $scope.find(this.$el.data("target"));
    } else {
      this.$target = $(this.$el.data("target"));
    }

    if (this.isNewsletter) {
      this.$target = window._newsLetterModal;
    }

    this.$prefill = this.$target.find('[data-lightbox="prefill"]');
    this.value = this.$el.data("value");
    this.modal =
      Modal.getInstance(this.$target[0]) ?? new Modal(this.$target[0]);
    this.init();
  }

  init = () => {
    this.$el.on("click", this.clickHandler);
  };

  clickHandler = (e) => {
    e.preventDefault();
    this.modal.show();
    if (this.$prefill) {
      this.$prefill.val(this.value);
    }
  };
}

export default Lightbox;
